import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { AccessPageWithAPI } from 'features/device.acl/ui/with-api';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
export function SharedAccessPage() {
    const { save_device_settings } = useContext(Z3KSettings);
    const onSetAcls = useCallback((acls) => {
        save_device_settings({ access: acls });
    }, [save_device_settings]);
    const onSetIndividualDeviceNote = useCallback((value) => save_device_settings({ individual_device_note: value }), [save_device_settings]);
    const onSetIndividualDeviceName = useCallback((value) => save_device_settings({ individual_device_name: value }), [save_device_settings]);
    if (Z3K_IS_USB_UTILITY) {
        return null;
    }
    return (_jsx(AccessPageWithAPI, { account: null, onSetAcls: onSetAcls, onSetIndividualDeviceNote: onSetIndividualDeviceNote, onSetIndividualDeviceName: onSetIndividualDeviceName }));
}
SharedAccessPage.isError = () => false;
SharedAccessPage.isWarning = SharedAccessPage.isError;
SharedAccessPage.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => (!Z3K_IS_USB_UTILITY && is_climatic) || (!Z3K_IS_USB_UTILITY && is_service_view);
